import Vue from "vue";
import VueRouter from "vue-router";
/* Layout */
import Layout from "@/layout/index.vue";
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => { });
};
Vue.use(VueRouter);
/*
  name:'router-name'             the name field is required when using <keep-alive>, it should also match its component's name property
                                 detail see : https://vuejs.org/v2/guide/components-dynamic-async.html#keep-alive-with-Dynamic-Components
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    hidden: true                 if true, this route will not show in the sidebar (default is false)
    alwaysShow: true             if true, will always show the root menu (default is false)
                                 if false, hide the root menu when has less or equal than one children route
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
    preventTab: true             if true, this route will not be recorded in routeTab
  }
*/
export const staticRoutes = [
    {
        path: "/",
        component: Layout,
        name: "Home",
        meta: {
            title: "首页",
            hidden: true,
        },
    },
    {
        path: "/profile",
        component: Layout,
        redirect: "/profile/index",
        meta: { hidden: true },
        children: [
            {
                path: "index",
                component: () => import(/* webpackChunkName: "profile" */ "@/views/profile/index.vue"),
                name: "Profile",
                meta: {
                    title: "个人中心",
                    icon: "user",
                },
            },
        ],
    },
    {
        path: "/error",
        component: Layout,
        redirect: "/error/404",
        name: "Error",
        meta: {
            hidden: true,
        },
        children: [
            {
                path: "404",
                component: () => import(/* webpackChunkName: "404" */ "@/views/error-page/404.vue"),
                meta: { title: "404", hidden: true, preventTab: true },
            },
            {
                path: "401",
                component: () => import(/* webpackChunkName: "401" */ "@/views/error-page/401.vue"),
                meta: { title: "401", hidden: true },
            },
        ],
    },
];
export const dynamicRoutes = [
    {
        path: "/data-manager",
        component: Layout,
        redirect: "/data-manager/audio",
        meta: {
            title: "内容管理",
            icon: "documentation",
            permissions: "c_dataManagement",
        },
        children: [
            {
                path: "graphic",
                component: () => import(
                /* webpackChunkName: "graphicManage" */ "@/views/data-manage/graphic/index.vue"),
                name: "Graphic",
                meta: {
                    title: "图文管理",
                    permissions: "c_graphic",
                },
            },
            {
                path: "graphic/edit",
                component: () => import(
                /* webpackChunkName: "graphicEdit" */ "@/views/data-manage/graphic/add/index.vue"),
                name: "GraphicEdit",
                meta: {
                    title: "图文编辑",
                    hidden: true,
                    preventTab: true
                },
            },
            {
                path: "video",
                component: () => import(
                /* webpackChunkName: "videoManage" */ "@/views/data-manage/video/index.vue"),
                name: "Video",
                meta: {
                    title: "视频管理",
                    permissions: "c_video",
                },
            },
            {
                path: "video/edit",
                component: () => import(
                /* webpackChunkName: "videoEdit" */ "@/views/data-manage/video/edit/index.vue"),
                name: "VideoEdit",
                meta: {
                    title: "视频编辑",
                    hidden: true,
                    preventTab: true
                },
            },
            {
                path: "audio",
                component: () => import(
                /* webpackChunkName: "audioManage" */ "@/views/data-manage/audio/index.vue"),
                name: "Audio",
                meta: {
                    title: "音频管理",
                    permissions: "c_audio",
                },
            },
            {
                path: "audio/edit",
                component: () => import(
                /* webpackChunkName: "audioEdit" */ "@/views/data-manage/audio/edit/index.vue"),
                name: "AudioEdit",
                meta: {
                    title: "音频编辑",
                    hidden: true,
                    preventTab: true
                },
            },
            {
                path: "question",
                component: () => import(
                /* webpackChunkName: "questionManage" */ "@/views/data-manage/question/list/index.vue"),
                name: "Question",
                meta: {
                    title: "题库管理",
                    permissions: "c_question_bank",
                },
            },
            {
                path: "question/edit",
                component: () => import(
                /* webpackChunkName: "questionManage" */ "@/views/data-manage/question/edit/index.vue"),
                name: "QuestionEdit",
                meta: {
                    title: "试题编辑",
                    hidden: true,
                    preventTab: true
                },
            },
            {
                path: "question/material-edit",
                component: () => import(
                /* webpackChunkName: "questionManage" */ "@/views/data-manage/question/material-edit/index.vue"),
                name: "MaterialQuestionEdit",
                meta: {
                    title: "试题编辑",
                    hidden: true,
                    preventTab: true
                },
            },
            {
                path: "test-paper",
                component: () => import(
                /* webpackChunkName: "testPaperManage" */ "@/views/data-manage/test-paper/list/index.vue"),
                name: "TestPaper",
                meta: {
                    title: "试卷管理",
                    permissions: "c_test_paper",
                },
            },
            {
                path: "test-paper/edit",
                component: () => import(
                /* webpackChunkName: "testPaperManage" */ "@/views/data-manage/test-paper/edit/index.vue"),
                name: "TestPaperEdit",
                meta: {
                    title: "试卷编辑",
                    hidden: true,
                    preventTab: true
                },
            },
            {
                path: "test-paper/preview",
                component: () => import(
                /* webpackChunkName: "testPaperManage" */ "@/views/data-manage/test-paper/preview/index.vue"),
                name: "TestPaperPreview",
                meta: {
                    title: "试卷预览",
                    // permissions: "c_video",
                    hidden: true,
                    preventTab: true
                },
            }
        ],
    },
    {
        path: "/course-manager",
        component: Layout,
        redirect: "/course-manager/index",
        meta: {
            title: "课程管理",
            icon: "education",
            alwaysShow: true,
            permissions: "c_courseManagement",
        },
        children: [
            // {
            //   path: "index",
            //   component: () =>
            //     import(
            //       /* webpackChunkName: "courseManage" */ "@/views/course-manage/index.vue"
            //     ),
            //   name: "CourseManager",
            //   meta: {
            //     title: "课程",
            //     permissions: "c_course",
            //   },
            // },
            // {
            //   path: "edit",
            //   component: () =>
            //     import(
            //       /* webpackChunkName: "courseEdit" */ "@/views/course-manage/edit/index.vue"
            //     ),
            //   name: "CourseEdit",
            //   meta: {
            //     title: "课程编辑",
            //     hidden: true,
            //     preventTab: true
            //   },
            // },
            {
                path: "columnList",
                component: () => import(
                /* webpackChunkName: "columnList" */ "@/views/course-manage/columnList/index.vue"),
                name: "columnList",
                meta: {
                    title: "专栏列表",
                    permissions: "c_colunmList",
                },
            },
            {
                path: "columnAdd",
                component: () => import(
                /* webpackChunkName: "columnAdd" */ "@/views/course-manage/columnAdd/index.vue"),
                name: "columnAdd",
                meta: {
                    title: "新建专栏",
                    hidden: true,
                    preventTab: true
                },
            },
            {
                path: "campList",
                component: () => import(
                /* webpackChunkName: "campList" */ "@/views/course-manage/campList/index.vue"),
                name: "campList",
                meta: {
                    title: "训练营列表",
                    permissions: "c_campList",
                },
            },
            {
                path: "termList",
                component: () => import(
                /* webpackChunkName: "termList" */ "@/views/course-manage/termList/index.vue"),
                name: "termList",
                meta: {
                    title: "营期列表",
                    hidden: true,
                    preventTab: true
                },
            },
            {
                path: "termAdd",
                component: () => import(
                /* webpackChunkName: "termList" */ "@/views/course-manage/termAdd/index.vue"),
                name: "termAdd",
                meta: {
                    title: "添加营期",
                    hidden: true,
                    preventTab: true
                },
            },
            {
                path: "studentList",
                component: () => import(
                /* webpackChunkName: "studentList" */ "@/views/course-manage/studentList/index.vue"),
                name: "studentList",
                meta: {
                    title: "学员列表",
                    hidden: true,
                    preventTab: true
                },
            },
            {
                path: "progressList",
                component: () => import(
                /* webpackChunkName: "progressList" */ "@/views/course-manage/progressList/index.vue"),
                name: "progressList",
                meta: {
                    title: "进度详情",
                    hidden: true,
                    preventTab: true
                },
            },
        ],
    },
    {
        path: "/config",
        component: Layout,
        redirect: "/config/index",
        meta: {
            title: "通用配置管理",
            icon: "edit",
            noredirect: true,
            alwaysShow: true,
            permissions: "c_managementConfigManagement",
        },
        children: [
            {
                path: "index",
                component: () => import(
                /* webpackChunkName: "configManage" */ "@/views/config-manage/index.vue"),
                name: "Config",
                meta: {
                    title: "通用配置",
                    permissions: "c_commonConfig",
                },
            },
        ],
    },
    {
        path: "/exam-manager",
        component: Layout,
        redirect: "/exam-manager/list",
        meta: {
            title: "考试管理",
            icon: "education",
            alwaysShow: true,
            permissions: "c_exam_manage",
        },
        children: [
            {
                path: "list",
                component: () => import(
                /* webpackChunkName: "examManage" */ "@/views/exam-manage/exam/list/index.vue"),
                name: "Examination",
                meta: {
                    title: "考试信息列表",
                    permissions: "c_exam_bank",
                },
            },
            {
                path: "edit",
                component: () => import(
                /* webpackChunkName: "examManage" */ "@/views/exam-manage/exam/edit/index.vue"),
                name: "ExamEdit",
                meta: {
                    title: "编辑考试",
                    hidden: true,
                    preventTab: true
                },
            },
            {
                path: "appraise",
                component: () => import(
                /* webpackChunkName: "examManage" */ "@/views/exam-manage/exam/appraise/index.vue"),
                name: "Appraise",
                meta: {
                    title: "批阅列表",
                    hidden: true,
                    preventTab: true
                },
            },
            {
                path: "appraise/preview",
                component: () => import(
                /* webpackChunkName: "examManage" */ "@/views/exam-manage/exam/appraise-preview/index.vue"),
                name: "AppraisePreview",
                meta: {
                    title: "批阅查看",
                    hidden: true,
                    preventTab: true
                },
            },
        ]
    },
    {
        path: "/student-manager",
        component: Layout,
        redirect: "/student-manager/index",
        meta: {
            title: "学员管理",
            icon: "user",
            noredirect: true,
            alwaysShow: true,
            permissions: "c_studentManagement",
        },
        children: [
            {
                path: "index",
                component: () => import(
                /* webpackChunkName: "studentManage" */ "@/views/student-manage/studentList/index.vue"),
                name: "StudentManager",
                meta: {
                    title: "学员列表",
                    permissions: "c_student",
                },
            },
            {
                path: "add",
                component: () => import(
                /* webpackChunkName: "courseEdit" */ "@/views/student-manage/addStudent/index.vue"),
                name: "StudentEdit",
                meta: {
                    title: "添加学员",
                    hidden: true,
                    preventTab: true
                },
            },
        ],
    },
    {
        path: "/courseExchangeManagement",
        component: Layout,
        redirect: "/config/index",
        meta: {
            title: "兑换码管理",
            icon: "edit",
            noredirect: true,
            alwaysShow: true,
            permissions: "c_courseExchangeManagement",
        },
        children: [
            {
                path: "index",
                component: () => import(
                /* webpackChunkName: "configManage" */ "@/views/exchange-manage/index.vue"),
                name: "list",
                meta: {
                    title: "课程兑换码",
                    permissions: "c_ExchangeList",
                },
            },
        ],
    },
    {
        path: "/statisticsManagement",
        component: Layout,
        redirect: "/statisticsManagement/columnStatistics",
        meta: {
            title: "统计分析管理",
            icon: "edit",
            noredirect: true,
            alwaysShow: true,
            permissions: "c_statisticsManagement",
        },
        children: [
            {
                path: "columnStatistics",
                component: () => import(
                /* webpackChunkName: "columnStatistics" */ "@/views/statistics-manage/column/index.vue"),
                name: "columnStatisticsList",
                meta: {
                    title: "专栏学习效果分析",
                    permissions: "c_ColumnStatistics",
                },
            },
            {
                path: "termStatistics",
                component: () => import(
                /* webpackChunkName: "termStatistics" */ "@/views/statistics-manage/term/index.vue"),
                name: "termStatisticsList",
                meta: {
                    title: "训练营学习效果分析",
                    permissions: "c_TermStatistics",
                },
            },
        ],
    },
    {
        path: "/systemJumpManagement",
        component: Layout,
        redirect: "/systemJumpManagement/index",
        meta: {
            title: "关联系统管理",
            icon: "edit",
            noredirect: true,
            alwaysShow: true,
            permissions: "c_systemJumpManagement",
        },
        children: [
            {
                path: "index",
                component: () => import(
                /* webpackChunkName: "systemJumpManagement" */ "@/views/system-jump/index.vue"),
                name: "systemJumpPage",
                meta: {
                    title: "系统跳转",
                    permissions: "c_systemJumpPage",
                },
            }
        ],
    },
    {
        path: "/liveManagement",
        component: Layout,
        redirect: "/liveManagement/liveList",
        meta: {
            title: "直播管理",
            icon: "edit",
            noredirect: true,
            alwaysShow: true,
            permissions: "c_liveManagement",
        },
        children: [
            {
                path: "liveList",
                component: () => import(
                /* webpackChunkName: "liveManagement" */ "@/views/live-manage/liveList/index.vue"),
                name: "liveList",
                meta: {
                    title: "直播列表",
                    permissions: "c_liveList",
                },
            },
            {
                path: "videoLibrary",
                component: () => import(
                /* webpackChunkName: "liveManagement" */ "@/views/live-manage/videoLibrary/index.vue"),
                name: "videoLibrary",
                meta: {
                    title: "视频库",
                    permissions: "c_videoLibrary",
                },
            },
            {
                path: "picLibrary",
                component: () => import(
                /* webpackChunkName: "liveManagement" */ "@/views/live-manage/image-bank/index.vue"),
                name: "picLibrary",
                meta: {
                    title: "图片库",
                    permissions: "c_picLibrary",
                },
            }
        ],
    },
    {
        path: "*",
        redirect: "/error/404",
        meta: { hidden: true, preventTab: true },
    },
];
const createRouter = () => new VueRouter({
    // base: process.env.BASE_URL,
    routes: staticRoutes,
});
const router = createRouter();
export default router;
